import CounterControl from 'components/InputNumberOfPeople/CounterControl';
import RoundedButton from 'components/RoundedButton';
import React from 'react';
import CurrencySwitch from 'reusable-components/controls/CurrencySwitch';

const CSS = require('./PeopleSelect.module.scss');

interface PeopleSelectProps {
  nrOfAdults: number;
  nrOfChildren: number;
  maxPeople: number;
  formattedPrice: string;
  onContactHost: () => void;
  onAdultsChange: (adults: number) => void;
  onChildrenChange: (children: number) => void;
}

function PeopleSelect({
  nrOfAdults,
  nrOfChildren,
  maxPeople = 8,
  formattedPrice,
  onContactHost,
  onAdultsChange,
  onChildrenChange,
}: PeopleSelectProps) {
  const onAdultsIncrease = () => {
    const newValue = Math.min(nrOfAdults + 1, maxPeople - nrOfChildren);
    onAdultsChange(newValue);
  };
  const onAdultsDecrease = () => {
    const newValue = Math.max(nrOfAdults - 1, 1);
    onAdultsChange(newValue);
  };

  const onChildrenIncrease = () => {
    const newValue = Math.min(nrOfChildren + 1, maxPeople - nrOfAdults);
    onChildrenChange(newValue);
  };
  const onChildrenDecrease = () => {
    const newValue = Math.max(nrOfChildren - 1, 0);
    onChildrenChange(newValue);
  };

  return (
    <div>
      <div className={CSS.Controls}>
        <CounterControl
          value={nrOfAdults}
          minValue={1}
          maxValue={maxPeople - nrOfChildren}
          onIncrease={onAdultsIncrease}
          onDecrease={onAdultsDecrease}
        >
          Adults
        </CounterControl>
        <CounterControl
          value={nrOfChildren}
          minValue={0}
          maxValue={maxPeople - nrOfAdults}
          onIncrease={onChildrenIncrease}
          onDecrease={onChildrenDecrease}
        >
          <span>Children</span>
          <span className={CSS.ChildrenLabel}>0 - 10 years</span>
        </CounterControl>
      </div>
      <div className={CSS.Price}>
        <div>
          <div>{formattedPrice} per person</div>
          <div className={CSS.PriceNotice}>price varies by group size</div>
        </div>
        <CurrencySwitch
          className={CSS.CurrencySwitch}
          trackingId="People select"
        />
      </div>
      {nrOfAdults + nrOfChildren >= maxPeople && (
        <div className={CSS.BigGroupNotice}>
          <p className={CSS.BigGroupNoticeText}>
            For groups with more than {maxPeople} people
          </p>
          <RoundedButton
            size="S"
            edgeRounding="medium"
            pink
            onClick={onContactHost}
            className={CSS.ContactHostButton}
          >
            Contact the host
          </RoundedButton>
        </div>
      )}
    </div>
  );
}

export default PeopleSelect;
